export default __webpack_public_path__ + "static/partners05-f3ee1c0f31eeb677559b690c4e4af340.svg";